import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';
import Home from './views/Home.vue';
import Dashboard from './views/Dashboard.vue';
import TelsasoftDashboard from './views/TelsasoftDashboard.vue';
import Reports from './views/Reports.vue';
import ReportHistory from './views/ReportHistory.vue';
import SpecialReports from './views/SpecialReports.vue';
import UserThresholds from './views/UserThresholds.vue';
import ThresholdProfiles from './views/ThresholdProfiles.vue';
import Sites from './views/Sites.vue';
import SiteGroups from './views/SiteGroups.vue';
import Users from './views/Users.vue';
import UserGroups from './views/UserGroups.vue';
import CommonObjects from './views/CommonObjects.vue';
import Trees from './views/Trees.vue';
import SiteBook from './views/SiteBook.vue';
import Alarms from './views/Alarms.vue';
//import GeoMap from './views/GeoMap.vue';
import GeoMap from './views/GeoMapNew.vue';
import PingTargets from './views/PingTargets.vue';
import AlarmCorrelations from './views/AlarmCorrelations.vue';
import AlarmModifications from './views/AlarmModifications.vue';
import PagingRules from './views/PagingRules.vue';
import PagingSubstitutions from './views/PagingSubstitutions.vue';
import Issues from './views/Issues.vue';
import Settings from './views/Settings.vue';
import Support from './views/Support.vue';
import Smtp from './views/Smtp';
import Snmp from './views/Snmp';
import NetworkDevices from './views/NetworkDevices';
import TelsasoftAdmin from './views/TelsasoftAdmin';
import DatabaseInfo from './views/DatabaseInfo';
import ApplicationLogs from './views/ApplicationLogs';

import Tutorials from './views/Tutorials';
import NetworkMaps from './views/NetworkMaps';
import NetworkCategories from './views/NetworkCategories';
import TelsappAI from './views/TelsappAI';
import NetworkDiscovery from './views/NetworkDiscovery';

import store from './store';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/home',
            name: 'home',
            component: Home
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard
        },
        {
            path: '/tsdashboard',
            name: 'tsdashboard',
            component: TelsasoftDashboard
        },
        {
            path: '/reports',
            name: 'reports',
            component: Reports
        },
        {
            path: '/reporthistory',
            name: 'reporthistory',
            component: ReportHistory
        },
        {
            path: '/specialreports',
            name: 'specialreports',
            component: SpecialReports
        },
        {
            path: '/userthresholds',
            name: 'userthresholds',
            component: UserThresholds
        },
        {
            path: '/thresholdprofiles',
            name: 'thresholdprofiles',
            component: ThresholdProfiles
        },
        {
            path: '/sites',
            name: 'sites',
            component: Sites
        },
        {
            path: '/sitegroups',
            name: 'sitegroups',
            component: SiteGroups
        },
        {
            path: '/users',
            name: 'users',
            component: Users
        },
        {
            path: '/usergroups',
            name: 'usergroups',
            component: UserGroups
        },
        {
            path: '/sitebookobjects',
            name: 'sitebookobjects',
            component: CommonObjects
        },
        {
            path: '/sitebooktrees',
            name: 'sitebooktrees',
            component: Trees
        },
        {
            path: '/sitebook',
            name: 'sitebook',
            component: SiteBook
        },
        {
            path: '/alarms/:filter?',
            name: 'alarms',
            component: Alarms
        },
        {
            path: '/geomap',
            name: 'geomap',
            component: GeoMap
        },
        {
            path: '/pingtargets',
            name: 'pingtargets',
            component: PingTargets
        },
        {
            path: '/alarmcorrelations',
            name: 'alarmcorrelations',
            component: AlarmCorrelations
        },
        {
            path: '/alarmmodifications',
            name: 'alarmmodifications',
            component: AlarmModifications
        },
        {
            path: '/pagingrules',
            name: 'pagingrules',
            component: PagingRules
        },
        {
            path: '/pagingsubstitutions',
            name: 'pagingsubstitutions',
            component: PagingSubstitutions
        },
        {
            path: '/issues',
            name: 'issues',
            component: Issues
        },
        {
            path: '/settings',
            name: 'settings',
            component: Settings
        },
        {
            path: '/support',
            name: 'support',
            component: Support
        },
        {
            path: '/smtp',
            name: 'smtp',
            component: Smtp
        },
        {
            path: '/snmp',
            name: 'snmp',
            component: Snmp
        },
        {
            path: '/networkdevices',
            name: 'networkdevices',
            component: NetworkDevices
        },
        {
            path: '/tsadmin',
            name: 'tsadmin',
            component: TelsasoftAdmin
        },
        {
            path: '/dbinfo',
            name: 'dbinfo',
            component: DatabaseInfo
        },
        {
            path: '/applicationlogs',
            name: 'applicationlogs',
            component: ApplicationLogs
        },
        {
            path: '/tutorials',
            name: 'tutorials',
            component: Tutorials
        },
        {
            path: '/networkmaps',
            name: 'networkmaps',
            component: NetworkMaps
        },
        {
            path: '/networkcategories',
            name: 'networkcategories',
            component: NetworkCategories
        },
        {
            path: '/telsappai',
            name: 'telsappai',
            component: TelsappAI
        },
        {
            path: '/networkdiscovery',
            name: 'networkdiscovery',
            component: NetworkDiscovery
        },
    ]
});

router.beforeEach((to, from, next) => {
    const executeRoute = function() {
        store.dispatch('handleRemoveLocks', 'ALL').then(() => {
            store.commit('setIsDirty', false);
            // If they go to any page besides the login page, then validate they have a valid unexpired JWT.
            if(to.name !== 'login') {
                if(localStorage.getItem('access_token') && !(TELSA.isTokenExpired(localStorage.getItem('access_token')))) {
                    if(to.name == null) {
                        // This is commented out because we are checking for a "start page" in App.vue.
                        //next('/home');
                    }
                    else {
                        next();
                        // // Check they have product permissions
                        // if(store.state.user.navigation_permissions[to.name] !== false) {
                        //     next();
                        // }
                        // else {
                        //     next('/home');
                        // }
                    }
                }
                else {
                    next('/login');
                }
            }
            // If they go to login page but theyre already logged in, then send them to home page.
            else {
                if(localStorage.getItem('access_token') && !(TELSA.isTokenExpired(localStorage.getItem('access_token')))) {
                    next('/home');
                }
                else {
                    next();
                }
            }
        });
    }

    if(store.state.isDirty) {
        store.commit('showConfirmModal', {
            title: 'Are you sure?',
            message: 'Are you sure you want to abandon your changes without saving?',
            type: 'warning',
            confirmAction: executeRoute
        });
    }
    else {
        store.commit('setAiAnalyzerGridAPI', null);
        executeRoute();
    }

});


export default router;